function getBootstrapPayload() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.__SUARTE_SSR__?.artwork ?? null;
}

export function getSsrArtworkBootstrap(artworkSlug) {
  const payload = getBootstrapPayload();
  if (!payload) {
    return null;
  }

  if (payload.slug !== artworkSlug) {
    return null;
  }

  return payload;
}
